// Keyboard shortcut cheatsheet. Press ? to open.

import { el, on } from '@/lib/dom';

const KEYS: { key: string; desc: string }[] = [
  { key: '⌘Z',         desc: 'Undo' },
  { key: '⌘⇧Z / ⌘Y',  desc: 'Redo' },
  { key: '⌘+ / ⌘-',   desc: 'Zoom in / out' },
  { key: '⌘0',         desc: 'Fit canvas' },
  { key: 'Space-drag', desc: 'Pan viewport' },
  { key: 'V',          desc: 'Toggle layer visibility (when layer focused)' },
  { key: 'S',          desc: 'Solo layer (when layer focused)' },
  { key: '⌫ / Del',    desc: 'Remove focused layer' },
  { key: '⌘↑ / ⌘↓',   desc: 'Move focused layer up / down' },
  { key: 'A',          desc: 'Open Add Layer menu' },
  { key: 'P',          desc: 'Toggle play / pause (animated layers)' },
  { key: 'R',          desc: 'Reset playback time to 0' },
  { key: 'X',          desc: 'Surprise me' },
  { key: 'G',          desc: 'Open preset gallery' },
  { key: 'B',          desc: 'Browse 5,480 effects (no repeat)' },
  { key: 'D',          desc: 'Open DSL editor' },
  { key: 'E',          desc: 'Open Export dialog' },
  { key: 'M',          desc: 'Toggle Studio mode (dot-gradient focus)' },
  { key: 'F',          desc: 'Toggle fullscreen' },
  { key: 'Z',          desc: 'Toggle zen mode (hide UI)' },
  { key: 'T',          desc: 'Toggle theme' },
  { key: '?',          desc: 'Toggle this help' },
  { key: 'Esc',        desc: 'Close any open modal' },
  { key: 'Drop / ⌘V',  desc: 'Import an image (drag-drop or paste)' },
];

let openInstance: { close: () => void } | null = null;

export function toggleCheatsheet(): void {
  if (openInstance) {
    openInstance.close();
    return;
  }
  openCheatsheet();
}

export function openCheatsheet(): void {
  if (openInstance) return;

  const dim = el('div', { class: 'modal-backdrop' });
  const dialog = el('div', { class: 'modal modal-cheats', role: 'dialog', ariaLabel: 'Keyboard shortcuts' });

  const head = el('div', { class: 'modal-head' }, [
    el('div', { class: 'modal-title' }, ['Keyboard']),
    el('div', { class: 'modal-subtitle' }, ['Press ? to toggle.']),
  ]);

  const grid = el('div', { class: 'cheats-grid' });
  for (const k of KEYS) {
    grid.appendChild(el('div', { class: 'cheat-key mono' }, [k.key]));
    grid.appendChild(el('div', { class: 'cheat-desc' }, [k.desc]));
  }

  dialog.append(head, grid);
  dim.appendChild(dialog);
  document.body.appendChild(dim);

  function close(): void {
    dim.remove();
    offKey();
    offClick();
    openInstance = null;
  }
  const offKey = on(window, 'keydown', (ev) => {
    if (ev.key === 'Escape' || ev.key === '?') {
      ev.preventDefault();
      close();
    }
  });
  const offClick = on(dim, 'click', (ev) => {
    if (ev.target === dim) close();
  });
  openInstance = { close };
}
